<template>
  <modal
    name="review"
    :adaptive="true"
    :click-to-close="false"
    height="auto"
    width="90%"
    :max-width="600"
    :pivot-y="0.2"
    @before-open="beforeOpen"
  >
    <Button class="close-button" @click="$modal.hide('review')">
      <v-icon slot="icon-end" name="times" />
    </Button>

    <Review :title="title" :amount="amount" :store-name="storeName" />
  </modal>
</template>

<script>
import Review from "@/components/Feedback/Review";

export default {
  name: "ReviewModal",
  components: { Review },
  props: {
    storeName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      amount: 5,
      title: "",
    };
  },
  methods: {
    beforeOpen(event) {
      this.amount = event.params.amount;
      this.title = event.params.title;
    },
  },
};
</script>

<style scoped>
>>> .review-modal {
  @apply p-0;
}
</style>
